module.exports = __webpack_public_path__ + "static/img/skeleton.204f14e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skeleton.svg
// module id = 5YsF
// module chunks = 1